import { useWorkspaceAuth } from "hooks/useWorkspace/useWorkspaceAuth";
import { Permissions } from "utils/permissions/permissionConstants";
import { McpConnectorCard } from "../McpConnectorCard/McpConnectorCard";

type ClaudeConnectorCardProps = {
  workspaceId: string;
  variant: "promo" | "manage";
  onDismiss?: () => void;
};

/** Backwards-compatible Claude promo wrapper. The Connections page uses all client cards. */
export const ClaudeConnectorCard = (props: ClaudeConnectorCardProps) => {
  const { canWorkspace, isLoading } = useWorkspaceAuth(props.workspaceId);
  if (isLoading || !canWorkspace(Permissions.WORKSPACE_API_KEY_LIST)) return null;
  return <McpConnectorCard {...props} client="claude" />;
};
